var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"title-box",style:({ borderColor: _vm.color, color: _vm.color })},[_c('i',{staticClass:"el-icon-notebook-1 icon"}),_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }